function pauseVimeoIframe(iframe: HTMLIFrameElement): void {
  iframe.contentWindow?.postMessage(
    JSON.stringify({ method: 'pause' }),
    'https://player.vimeo.com',
  );
}

function initVideoBreakpointPause(): void {
  const desktopVideo = document.querySelector<HTMLIFrameElement>('iframe[data-video="desktop"]');
  const mobileVideo = document.querySelector<HTMLIFrameElement>('iframe[data-video="mobile"]');
  if (!desktopVideo || !mobileVideo) return;

  const mql = window.matchMedia('(min-width: 768px)');
  mql.addEventListener('change', (e) => {
    if (e.matches) {
      // モバイル → デスクトップ: モバイル側を停止
      pauseVimeoIframe(mobileVideo);
    } else {
      // デスクトップ → モバイル: デスクトップ側を停止
      pauseVimeoIframe(desktopVideo);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initVideoBreakpointPause();

  const tabContainer = document.querySelector('[data-tabs]');
  if (!tabContainer) return;

  const tabs = tabContainer.querySelectorAll<HTMLButtonElement>('[role="tab"]');
  const panels = tabContainer.querySelectorAll<HTMLElement>('[role="tabpanel"]');
  const indexPanels = document.querySelectorAll<HTMLElement>('[data-tab-index]');

  tabs.forEach((tab, tabIndex) => {
    tab.addEventListener('click', () => {
      // 全タブを非アクティブに
      tabs.forEach((t) => {
        t.disabled = false;
        t.setAttribute('aria-selected', 'false');
      });
      // 全パネルを非表示に
      panels.forEach((p) => (p.hidden = true));

      // クリックされたタブをアクティブに
      tab.disabled = true;
      tab.setAttribute('aria-selected', 'true');

      // 対応するパネルを表示
      const panelId = tab.getAttribute('aria-controls');
      const panel = tabContainer.querySelector(`#${panelId}`);
      if (panel instanceof HTMLElement) {
        panel.hidden = false;
      }

      // INDEXパネルを切り替え
      indexPanels.forEach((ip) => {
        ip.hidden = ip.dataset.tabIndex !== String(tabIndex);
      });

      // Splideレイアウト再計算
      window.dispatchEvent(new Event('resize'));
    });
  });
});
